export default __webpack_public_path__ + "static/media/logo.7c5c904e.svg";